import { createStore } from "vuex";
import modules from "./modules";

const store = createStore({
  modules,
  strict: process.env.NODE_ENV !== "production"
});

// Untuk debugging
if (process.env.NODE_ENV !== "production") {
  console.log('Registered Vuex modules:', Object.keys(store._modules.root._children));
}

export default store;